import EmptyEntity from 'components/atoms/empty-entity/EmptyEntity'
import Table from 'components/molecules/table/Table'
import { orderRequestsHeaders } from 'lib/helpers/constants/columns/orderRequestsHeaders'
import React from 'react'
import { useTranslation } from 'react-i18next'

const Orders = ({ data }: any) => {

    const { t } = useTranslation()

    if (data?.data?.length === 0) {
        return (
            <EmptyEntity name='Orders' />
        )
    }

    return (
        <div>
            <div className='space-y-2'>
                <div className='font-inter-medium text-xl text-primaryTextColor'>
                    {t("All Orders")} ({data?.data?.length})
                </div>
                <Table
                    search=''
                    columns={orderRequestsHeaders}
                    data={data?.data || []}

                />
            </div>
        </div>
    )
}

export default Orders